module.exports = __webpack_public_path__ + "img/solution-electric-function-icon-2.6d6364a3.svg";